// Do not modify this file by hand!
// Re-generate this file by running lit-localize.

/**
 * The locale code that templates in this source code are written in.
 */
export const sourceLocale = ``;

/**
 * The other locale codes that this application is localized into. Sorted
 * lexicographically.
 */
export const targetLocales = [
  `de`,
  `en`,
];

/**
 * All valid project locale codes. Sorted lexicographically.
 */
export const allLocales = [
  ``,
  `de`,
  `en`,
];
